import { render, staticRenderFns } from "./ActionsAfterSubmit.vue?vue&type=template&id=68ed9427"
import script from "./ActionsAfterSubmit.vue?vue&type=script&lang=js"
export * from "./ActionsAfterSubmit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports